import { render } from "./CoBrandAurora.vue?vue&type=template&id=213b120b&scoped=true"
import script from "./CoBrandAurora.vue?vue&type=script&lang=js"
export * from "./CoBrandAurora.vue?vue&type=script&lang=js"

import "./CoBrandAurora.vue?vue&type=style&index=0&id=213b120b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213b120b"]])

export default __exports__